import { useState } from "react";

export interface BillingRow {
  label: string;
  value: string;
}

interface Props {
  subtotal: number;
  tax: number;
  total: number;
  currency?: string;
  rows?: BillingRow[];
}

const ChevronIcon = ({ open }: { open: boolean }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}>
    <path d="M6 9l6 6 6-6" stroke="#1F2024" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const BillingDetails = ({ subtotal, tax, total, currency = "₹", rows }: Props) => {
  const [open, setOpen] = useState(true);
  const breakdownRows: BillingRow[] = rows ?? [
    { label: "Amount", value: `${currency}${subtotal.toFixed(2)}` },
    { label: "Total Tax", value: `${currency}${tax.toFixed(2)}` },
  ];


  return (
    <section className="bg-white rounded-[6px] border border-[#E6EEFF] overflow-hidden">
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full h-[47px] flex items-center justify-between px-3 border-0 bg-transparent" aria-expanded={open} >
        <span className="font-sansation font-bold text-[#1F2024] text-[16px]">
          Billing Details
        </span>
        <ChevronIcon open={open} />
      </button>

      {open && (
        <div>
          <div className="border-t border-[#E8E9F1]" />
          <div className="pt-2 pb-3">
            {breakdownRows.map((r) => (<Row key={r.label} label={r.label} value={r.value} />))}
          </div>
          <div className="border-t border-[#E8E9F1]" />
          <div className="pt-1 pb-2">
            <Row label="Total Amount" value={`${currency}${total.toFixed(2)}`} bold />
          </div>
        </div>
      )}
    </section>
  );
};

const Row = ({ label, value, bold }: { label: string; value: string; bold?: boolean }) => (
  <div className="flex items-center justify-between px-3 py-2">
    <span className="font-opensans text-[14px] text-[#494A50]">{label}</span>
    <span className={`font-opensans ${bold ? "font-semibold text-[#1F2024]" : "font-semibold text-[#1F2024]"} text-[16px]`} >
      {value}
    </span>
  </div>
);

export default BillingDetails;
